import React from "react";
import styles from "./RankTable.module.css";
import * as d3 from "d3";
import {
  year,
  parse_time,
  color,
  calculateRank,
  colorValues,
  rankArr,
  getCurrentYear,
  getPreviousYear,
} from "../../helperFunctions";

const text_color = d3
  .scaleThreshold()
  .domain([-15, -10, -5, -1, 1, 5, 10, 15])
  .range([
    "#fff",
    "#000",
    "#000",
    "#000",
    "#000",
    "#000",
    "#000",
    "#000",
    "#fff",
  ]);

const RankTable = ({ data, updated, handleScrollTo }) => {
  return (
    <div className={styles.RankTable}>
      <h4>Priority Community Area rankings</h4>
      <p className={styles.Click}>
        Click on any community area to jump to profile.
      </p>
      <div className={styles.Key}>
        <div className={styles.ViolenceDesc}>
          <p>Less Violent</p>
          <p>More Violent</p>
        </div>
        <div className={styles.ColorKey}>
          {colorValues.map((d) => {
            return (
              <span
                style={{
                  backgroundColor: d,
                }}
              />
            );
          })}
        </div>
        <div className={styles.ValueKey}>
          {rankArr.map((d, i) => {
            return (
              <div>
                <span>{d3.format("+")(d)}</span>
              </div>
            );
          })}
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th className={styles.Rank} />
            <th>COMMUNITY AREA</th>
            <th>POPULATION</th>
            <th>{year - 1}</th>
            <th>{year}</th>
            <th>
              CHANGE
              <br />
              PER 10K
            </th>
          </tr>
        </thead>
        <tbody>
          {data
            .sort((a, b) =>
              calculateRank(a[1].victimizations, updated, a[1].population) <
              calculateRank(b[1].victimizations, updated, b[1].population)
                ? 1
                : -1
            )
            .map((d, i) => {
              const rank = calculateRank(
                d[1].victimizations,
                updated,
                d[1].population
              );
              return (
                <tr
                  onClick={() =>
                    handleScrollTo(d[0].split(" ").join("").toLowerCase())
                  }
                >
                  <td className={styles.Rank}>{i + 1}.</td>
                  <td className={styles.Name}>{d[0].toLowerCase()}</td>
                  <td>{d3.format(",")(d[1].population)}</td>
                  <td>
                    {getPreviousYear(d[1].victimizations, updated).length}
                  </td>
                  <td>{getCurrentYear(d[1].victimizations, updated).length}</td>
                  <td
                    className={styles.PerCapita}
                    style={{
                      backgroundColor: color(rank),
                      color: text_color(rank),
                    }}
                  >
                    {d3.format("+.1f")(rank)}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default RankTable;
